import { render, staticRenderFns } from "./SettingsAdminHeader.vue?vue&type=template&id=69f0f3f5&"
import script from "./SettingsAdminHeader.vue?vue&type=script&lang=js&"
export * from "./SettingsAdminHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports